export const redirects = {
    '/join-440/': '/join/',
    '/artist-application/': '/join/',
    '/artist-application-form/': '/join/',
    '/upgrades-form/': '/releaseboosters/',
    '/artist-submission/': '/lam-application/',
    '/intake-form/': '/artist-intake-form/',
    '/440-monthly-plan/': '/payment/',
    '/440-annual-plan/': '/payment/',
    '/standard-package/': '/payment/',
    '/elite-package/': '/payment/',

    '/application-payment/': '/payment/',
    '/membership-payment/': '/payment/',
    '/payment-b/': '/payment/',
    '/payment-c/': '/payment/',
    '/core-payment-form/': '/payment/',
    '/select-payment-form/': '/payment/',
    '/welcome-to-core/': '/',
    '/welcome-to-select/': '/',
    '/application-update/': '/',
    '/sample-page/': '/',
    '/syncform/': '/',
    '/artist/lex-bratcher/': '/',
    '/artist/shaolinn/': '/',
    '/artist/erykah-officer/': '/',
    '/artist/lynae-vanee/': '/',
    '/artist/father-romar/': '/',
    '/artist/swayvo-twain/': '/',

    '/releaseboosters/apple-music-encoding/': '/releaseboosters/',
    '/releaseboosters/artist-digital-epk-onesheet/': '/releaseboosters/',
    '/releaseboosters/content-clips-for-social-channel/': '/releaseboosters/',
    '/releaseboosters/distribute-your-lyrics-everywhere/': '/releaseboosters/',
    '/releaseboosters/full-lyrics-video-visualizer/': '/releaseboosters/',
    '/releaseboosters/music-video-promotion/': '/releaseboosters/',
    '/releaseboosters/newsletter-spotlight/': '/releaseboosters/',
    '/releaseboosters/playlist-pitching/': '/releaseboosters/',
    '/releaseboosters/podcast-interview/': '/releaseboosters/',
    '/releaseboosters/revolt-editorial-interview/': '/releaseboosters/',
    '/releaseboosters/revolt-feature/': '/releaseboosters/',
    '/releaseboosters/revolts-editors-list/': '/releaseboosters/',
    '/releaseboosters/rollout-assistance/': '/releaseboosters/',
    '/releaseboosters/rush-delivery/': '/releaseboosters/',
    '/releaseboosters/social-post/': '/releaseboosters/',
    '/releaseboosters/spotify-canvas-creation/': '/releaseboosters/',
    '/releaseboosters/the-artist-playbook/': '/releaseboosters/',
    '/releaseboosters/vevo-channel-request/': '/releaseboosters/',
    '/releaseboosters/welcome-to-440-showcase/': '/releaseboosters/',
    '/apple-music-video-encoding-asset-submission/': '/support/',
    '/content-clips-for-social-channel-asset-submission/': '/support/',
    '/full-lyrics-video-visualizer-asset-submission/': '/support/',
    '/lyrics-distribution-asset-submission/': '/support/',
    '/newsletter-spotlight-asset-submission/': '/support/',
    '/rollout-assistance-asset-submission/': '/support/',
    '/rush-delivery-asset-submission/': '/support/',
    '/welcome-to-440-showcase/': '/support/',
    '/artist-epk-upgrade/': '/support/',
    '/editorial-playlist-submission-form/': '/support/',
    '/podcast-submission/': '/support/',
    '/fast-track/': '/payment/',
};
